/**
 * Tally local para "Sugeridos para vos" (doc 83 §B.13.4). Sin backend.
 */
import { DashboardWidgetType } from './dashboardStorage';

const PREFIX = 'shc_dashboard_usage_';

interface Usage {
  screens: Record<string, number>;
  devices: Record<string, number>;
  speakers: Record<string, number>;
  rooms: Record<string, number>;
  updatedAt: number;
}

function empty(): Usage {
  return { screens: {}, devices: {}, speakers: {}, rooms: {}, updatedAt: Date.now() };
}

function load(userId: number | string): Usage {
  try {
    const raw = localStorage.getItem(`${PREFIX}${userId}`);
    if (!raw) return empty();
    const u = JSON.parse(raw) as Usage;
    const weeks = (Date.now() - (u.updatedAt || Date.now())) / (7 * 24 * 3600_000);
    if (weeks >= 1) {
      const decay = Math.pow(0.7, Math.floor(weeks));
      const scale = (m: Record<string, number>) => Object.fromEntries(Object.entries(m).map(([k, v]) => [k, v * decay]));
      return { screens: scale(u.screens || {}), devices: scale(u.devices || {}), speakers: scale(u.speakers || {}), rooms: scale(u.rooms || {}), updatedAt: Date.now() };
    }
    return { screens: u.screens || {}, devices: u.devices || {}, speakers: u.speakers || {}, rooms: u.rooms || {}, updatedAt: u.updatedAt };
  } catch { return empty(); }
}

function save(userId: number | string, u: Usage) {
  try { localStorage.setItem(`${PREFIX}${userId}`, JSON.stringify({ ...u, updatedAt: Date.now() })); } catch { /* ignore */ }
}

export function bumpUsage(kind: 'screen' | 'device' | 'speaker' | 'room', id: string | number) {
  const user = (() => { try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } })();
  if (!user?.id) return;
  const u = load(user.id);
  const key = String(id);
  if (kind === 'screen') u.screens[key] = (u.screens[key] || 0) + 1;
  if (kind === 'device') u.devices[key] = (u.devices[key] || 0) + 1;
  if (kind === 'speaker') u.speakers[key] = (u.speakers[key] || 0) + 1;
  if (kind === 'room') u.rooms[key] = (u.rooms[key] || 0) + 1;
  save(user.id, u);
}

export function usageEventCount(userId: number | string): number {
  const u = load(userId);
  const sum = (m: Record<string, number>) => Object.values(m).reduce((a, b) => a + b, 0);
  return sum(u.screens) + sum(u.devices) + sum(u.speakers) + sum(u.rooms);
}

export function suggestWidgetTypes(userId: number | string, already: Set<DashboardWidgetType>): DashboardWidgetType[] {
  const u = load(userId);
  const top = (m: Record<string, number>) => Object.entries(m).sort((a, b) => b[1] - a[1]).map(([k]) => k);
  const out: DashboardWidgetType[] = [];
  const add = (t: DashboardWidgetType) => { if (!already.has(t) && !out.includes(t)) out.push(t); };
  if (top(u.devices).length) add('device');
  if (top(u.rooms).length) add('room');
  const screens = top(u.screens);
  if (screens.includes('video')) add('camera');
  if (screens.includes('music')) add('sonos');
  if (screens.includes('realtime')) add('solar');
  if (screens.includes('reports')) add('report_chart');
  if (screens.includes('climate')) add('climate');
  if (screens.includes('pileta')) add('pileta');
  if (screens.includes('softphone')) add('phone');
  add('favorites');
  add('attention');
  return out.slice(0, 6);
}
